// A helper function that finds one video object in an array videos objects and returns the staticURL string pointing to the videop
// To use it, pass an object that has two properties: fileName and videos
// Where fileName is the file name of the video you want to find, and videos is the array of videos you are searching through.
export default function findVideo(object) {
  const { fileName, videos } = object;

  // Search the videos array looking for a matching filename
  const videoObj = videos.find(video => {
    return video.node.base.includes(fileName);
  });

  // Deconstruct the video object so that it's only pointing to the url string
  return videoObj.node.publicURL;
}
